import React from "react";
import { ContactUsText2 } from "./__ContactUs";
import NavbarSave from "../components/navbar-save";
import Footer from "../components/footer";

const title = "Shipping Policy";

const Shipping = () => {
  return (
    <>
      <NavbarSave />
      <div className="bg-white w-100 h-100 overflow-y-auto" style={{ paddingTop: 156 }}>
        <div className="container">
          <div className="fs-1 fw-bold">{title}</div>
          <p className="mb-5">Last updated: {new Date().getFullYear()}</p>
          <div className="text-left">
            <ShippingText />
          </div>
          <div className="py-5" />
          <div className="py-5" />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Shipping;

function ShippingText() {
  return (
    <>
      <div className="fs-3 fw-semibold mt-5">1. Overview</div>
      <p className="fs-5">
        This Shipping Policy outlines the delivery procedures and timelines for 
        <strong> SAVE (Secure AI-Based Vulnerability Assessment Tool for Enterprises)</strong>, 
        a digital cybersecurity software platform developed, owned, and operated solely by 
        <strong> CYBERSECOPS PRIVATE LIMITED</strong>. SAVE is a software-as-a-service (SaaS) product 
        provided entirely through secure digital channels. As such, there is 
        <strong> no physical shipping, packaging, or delivery of goods</strong> involved.
      </p>

      <div className="fs-3 fw-semibold mt-5">2. Nature of Delivery</div>
      <p className="fs-5">
        Since SAVE is a cloud-based software solution, all services are delivered digitally. 
        Upon successful completion of payment or registration, users are granted access to 
        the platform via secure login credentials. Delivery of access typically occurs 
        <strong> instantly or within a few minutes</strong> of payment confirmation. 
        All communications related to account activation and access instructions are sent 
        to the registered email address provided during signup.
      </p>

      <div className="fs-3 fw-semibold mt-5">3. Digital Access and Activation</div>
      <p className="fs-5">
        After subscription or purchase:
      </p>
      <ul className="fs-5">
        <li>Users receive an email confirmation with their account details and a secure login link.</li>
        <li>Access to SAVE’s dashboard and tools is enabled immediately once the payment is verified.</li>
        <li>For enterprise clients, onboarding and configuration support may take up to 
        <strong> 24–48 hours</strong> depending on security setup requirements.</li>
      </ul>
      <p className="fs-5">
        No CDs, USB drives, printed manuals, or any other physical items are shipped or distributed as part of this service.
      </p>

      <div className="fs-3 fw-semibold mt-5">4. No Physical Shipping</div>
      <p className="fs-5">
        CYBERSECOPS PRIVATE LIMITED does not engage in physical product distribution for SAVE or its associated tools. 
        Therefore, there are no shipping charges, courier timelines, or delivery tracking numbers associated with your purchase. 
        All interactions, subscriptions, and communications are managed through secure digital interfaces on our website and platform.
      </p>

      <div className="fs-3 fw-semibold mt-5">5. Delivery Timelines</div>
      <p className="fs-5">
        Digital delivery and activation are typically completed immediately after payment confirmation. 
        However, in rare cases such as high transaction volume, system maintenance, or technical verification, 
        activation may take up to <strong> 24 hours</strong>. In such cases, our support team will promptly notify 
        the customer and ensure that access is granted as soon as possible.
      </p>

      <div className="fs-3 fw-semibold mt-5">6. Account Access Issues</div>
      <p className="fs-5">
        If you do not receive your access credentials within the stated time frame or encounter difficulties 
        accessing your SAVE account, please check your spam/junk folder first. If the issue persists, contact 
        our support team immediately at the provided contact information below. Our technical team will verify 
        your payment and restore access without delay.
      </p>

      <div className="fs-3 fw-semibold mt-5">7. Service Availability and Maintenance</div>
      <p className="fs-5">
        SAVE operates 24/7 on secure cloud servers managed by CYBERSECOPS PRIVATE LIMITED. 
        While we strive for uninterrupted service availability, occasional downtime may occur 
        for scheduled maintenance or updates. Users will be informed in advance of such events 
        whenever possible. These temporary service interruptions do not qualify for refunds or compensation.
      </p>

      <div className="fs-3 fw-semibold mt-5">8. Customer Support and Assistance</div>
      <p className="fs-5">
        Our dedicated support team is available to assist users with all delivery, access, or 
        activation-related queries. For any assistance related to account setup, activation delays, 
        or technical troubleshooting, please contact our support team using the contact details below.
      </p>
      <ContactUsText2 />

      <div className="fs-3 fw-semibold mt-5">9. Policy Updates</div>
      <p className="fs-5">
        CYBERSECOPS PRIVATE LIMITED reserves the right to modify or update this Shipping Policy 
        at any time without prior notice to reflect changes in operational procedures or technology. 
        The “Last Updated” date at the top of this page indicates the most recent revision.
      </p>
    </>
  );
}
